import React from "react";
import EACombobox from "../../EACombobox";
import EARadioGroup from "../../EARadioGroup";

/**
 * Komponente zur Darstellung von Organisationen und Funktionalen Rollen
 * @param organisations
 * @param functions
 * @param organisation die darzustellende Value
 * @param handleOrganisationChanged
 * @param errors Alle gesammelten Fehlermeldungen
 * @returns {JSX.Element}
 * @constructor
 */
function OrganisationFunctionSelectionComponent({ organisations, functions, organisation, handleOrganisationChanged, errors }) {
    return (
        <div>
            <EACombobox
                id={"Organisationsbezeichnung"}
                label="Organisationsbezeichnung"
                required
                loading={organisations.loading}
                value={organisation.organisation}
                error={errors.organisation}
                onChange={(e, newValue) => handleOrganisationChanged("organisation", newValue ? newValue.id : null)}
                getOptionLabel={(o) => `${o.bezeichnung} - ${o.adresse.strasse} ${o.adresse.hausnummer}, ${o.adresse.plz} ${o.adresse.ort}`}
                options={organisations.data}
            />
            <EARadioGroup
                label="Funktion:"
                value={organisation.funktionaleRolle ? organisation.funktionaleRolle.key : null}
                onChange={(e, newValue) => {
                    handleOrganisationChanged("funktionaleRolle", newValue);
                }}
                error={errors.funktionaleRolle}
                required
                options={functions}
                optionKey={"key"}
                optionTitle={"title"}
                row
            />
        </div>
    );
}

export default OrganisationFunctionSelectionComponent;
